import React from 'react';
import { FaFilePdf, FaLinkedin } from 'react-icons/fa';
import resumePdf from '../assets/UX-Resume-2026.pdf';
import './Contact.css';

export default function Contact() {
  return (
    <div className="contact-container">
      <h1>About Me</h1>
      <p className="intro-text">
        Hi, I'm Elizabeth — a UX designer and product manager with 4 years building digital experiences for startups, small businesses, and nonprofits. I founded a web design consultancy and currently lead product and UX for an AI-powered home affordability simulator at AdaptableLogic. I combine user research, hands-on design, and front-end development to ship products people actually use.
      </p>

      <h2>Contact</h2>
      <p className="contact-text">
        Feel free to reach out to discuss projects, collaborations, or just to say hello!
        email: elizabeth10harrington@gmail.com
      </p>


        <ul className="contact-links">
            <li>
                <a className="contact-button" href={resumePdf} target="_blank" rel="noopener noreferrer">
                    <FaFilePdf className="icon" />
                    View My Resume (PDF)
                </a>
            </li>
            <li>
                <a className="contact-button" href="https://www.linkedin.com/in/elizabeth-harrington-44815b252/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin className="icon" />
                    LinkedIn Profile
                </a>
            </li>
        </ul>
    </div>
  );
}
